<template>
  <div class="socialFeed">
    <ul class="socialFeed-list">
      <li v-for="(item,index) in items" :key="index">
        <div class="socialItem">
          <div class="socialItem-title" v-if="platform === 'linkedin'">{{item.title}}</div>
          <div class="socialItem-date">{{item.date}}</div>
          <div class="socialItem-content">{{item.content}}</div>
          <div class="socialItem-image">
            <img :src="item.image" alt="">
          </div>
        </div>
      </li>
    </ul>
  </div>
</template>

<script>
export default {
    props: ["endpoint", "platform", "endpointId"],
    created() {
        this.fetchData();
        // this.fetchFakeData();
    },
    data() {
        return {
            items: [],
            fakeFeed: {
                feed: [
                    {
                        date: "2018-08-29T18:41:14.5894631+00:00",
                        content: "This is a test post content. blah blah blah.",
                        image: "https://www.fillmurray.com/200/300"
                    },
                    {
                        date: "2018-08-29T18:41:14.5894631+00:00",
                        content: "This is a test post content. blah blah blah.",
                        image: "https://www.fillmurray.com/200/300"
                    },
                    {
                        date: "2018-08-29T18:41:14.5894631+00:00",
                        content: "This is a test post content. blah blah blah.",
                        image: "https://www.fillmurray.com/200/300"
                    }
                ]
            }
        };
    },
    methods: {
        fetchData() {
            fetch(`${this.endpoint}?id=${this.endpointId}`)
                .then(res => res.json())
                .then(data => {
                  this.items = data;
                });
        },
        fetchFakeData() {
          this.items = this.fakeFeed.feed;
        }
    }
};
</script>

